import { useMutation, useQueryClient } from "react-query";
import {
  createSenderId,
  topPlatformCredit,
} from "../../../services/platformCredit";

export const useTopUpPlatformCredit = () => {
  return useMutation((data) => topPlatformCredit(data));
};

export const useCreateSenderId = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createSenderId(data), {
    onSuccess: () => {
      queryClient.invalidateQueries("getSenderList");
    },
  });
};
